import { render, staticRenderFns } from "./EffectReportContent.vue?vue&type=template&id=788c7ea8&scoped=true"
import script from "./EffectReportContent.vue?vue&type=script&lang=js"
export * from "./EffectReportContent.vue?vue&type=script&lang=js"
import style0 from "./EffectReportContent.vue?vue&type=style&index=0&id=788c7ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c7ea8",
  null
  
)

export default component.exports